export const LOGIN_EMAIL = 'LOGIN_EMAIL'
export const SET_STREAM = 'SET_STREAM'
export const TOGGLE_FILLER_HIDE = 'TOGGLE_FILLER_HIDE'
export const SET_AD_CODE= 'SET_AD_CODE'
export const SET_GUEST_MODE= 'SET_GUEST_MODE'
